import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { Row as ReactRow } from 'reactstrap';
import styled from 'styled-components';
import { TextWithGradient } from '../../VuexyDesign/atoms/Text';
import { Col, Row } from '../../VuexyDesign/atoms/_index';
import { noBigTablet, useIsDesktop, useIsMobile } from '../../style/constants';

interface TableProps {
  spacingTop?: string;
}

function DIstributionCompareChooseUs({ spacingTop = '5rem' }: TableProps) {
  const compareData = [
    {
      id: 1,
      featureName: 'organisms:noFeePerRelease',
      VIRPP: true,
      Tunecore: true,
      Distrokid: true,
    },
    {
      id: 2,
      featureName: 'organisms:keepYourRoyalties',
      VIRPP: true,
      Tunecore: true,
      Distrokid: true,
    },
    {
      id: 3,
      featureName: 'organisms:salesAndPerformanceData',
      VIRPP: true,
      Tunecore: true,
      Distrokid: false,
    },
    {
      id: 4,
      featureName: 'organisms:realTimeStatistics',
      VIRPP: true,
      Tunecore: false,
      Distrokid: false,
    },
    {
      id: 5,
      featureName: 'organisms:getFeedbackOnDemos',
      VIRPP: true,
      Tunecore: false,
      Distrokid: false,
    },
    {
      id: 6,
      featureName: 'organisms:joinContestsFromProfessionals',
      VIRPP: true,
      Tunecore: false,
      Distrokid: false,
    },

    {
      id: 7,
      featureName: 'organisms:oneMarketingLink',
      VIRPP: true,
      Tunecore: false,
      Distrokid: false,
    },

    {
      id: 8,
      featureName: 'organisms:customRecordLabelName',
      VIRPP: true,
      Tunecore: false,
      Distrokid: false,
    },
  ];

  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();
  const triggerDivRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation('organisms');

  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!triggerDivRef.current) {
        return;
      }

      const triggerPoint =
        triggerDivRef.current.getBoundingClientRect().top + window.pageYOffset;

      const triggerPoint2 =
        triggerDivRef.current.getBoundingClientRect().bottom +
        window.pageYOffset;

      if (
        window.scrollY > triggerPoint &&
        window.scrollY < triggerPoint2 + 960
      ) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [sticky]);

  return (
    <>
      <div
        className={` ${
          isMobile ? 'w-100' : 'w-75'
        } align-items-center d-flex flex-column text-center mx-auto mt-3 px-1`}
      >
        <TextWithGradient className="mb-1">
          {t('distributionLanding:compareDistribution') as string}
        </TextWithGradient>
        <h2 className={`custom-heading-font-2 ${isMobile ? 'w-100' : 'w-75'} `}>
          {t('distributionLanding:thisIsWhyYouChoose') as string}
        </h2>
        <p
          style={{ marginRight: '1rem', marginLeft: '1rem' }}
          className={`custom-font-text-regular-normal paragraph-color  ${
            isMobile ? 'w-100' : 'w-75'
          } mt-1 `}
        >
          {t('distributionLanding:atVirppWeChoose') as string}
        </p>
      </div>
      <div
        className={`mb-5 d-flex flex-column justify-content-center mx-auto mt-1
     ${isMobile ? 'w-100' : 'w-75'}`}
      >
        <PlanTable ref={triggerDivRef}>
          <TopHeaderRow sticky={sticky} style={{ top: spacingTop }}>
            <TopBarRow1>
              {isDesktop ? (
                <Col xs={0} xl={5} className="d-flex justify-center">
                  <div className="d-flex flex-column">
                    <span className="custom-font-text-medium-medium mr-1 text-capitalize">
                      {t('distributionLanding:features') as string}
                    </span>
                    <Subtitle className="custom-font-text-small-normal">
                      {t('distributionLanding:getAccessFeatures') as string}
                    </Subtitle>
                  </div>
                </Col>
              ) : (
                <Col xs={0} xl={5} className="d-flex justify-center p-0" />
              )}
              <Col
                xs={4}
                xl={3}
                className="d-flex justify-content-center align-items-center position-sticky"
              >
                <Image
                  height={isDesktop ? 26 : 22}
                  width={isDesktop ? 109 : 109}
                  src="/static/images/logo.png"
                  alt="logo-virpp"
                  style={{ maxWidth: '100%' }}
                />
              </Col>
              <Col
                xs={4}
                xl={2}
                className="d-flex justify-content-center align-items-center position-sticky"
              >
                <div>
                  <Image
                    height={isDesktop ? 26 : 16}
                    width={isDesktop ? 115 : 100}
                    src="/static/images/distribution-landing/tunecore.png"
                    alt="logo-tunecore"
                    style={{ maxWidth: '100%' }}
                  />
                </div>
              </Col>
              <Col
                xs={4}
                xl={2}
                className="d-flex justify-content-center align-items-center position-sticky"
              >
                <Image
                  height={isDesktop ? 26 : 16}
                  width={isDesktop ? 115 : 100}
                  src="/static/images/distribution-landing/distrokid.png"
                  alt="logo-distrokid"
                  style={{ maxWidth: '100%' }}
                />
              </Col>
            </TopBarRow1>
          </TopHeaderRow>
          {compareData.map((item, index) => (
            <Row
              key={`compare-data-${item.id}`}
              className={`w-100 mx-auto p-1 border ${
                index % 2 === 0 ? 'bg-light' : ''
              }`}
              style={{
                background: ` ${
                  index % 2 !== 0 ? 'rgba(75, 70, 92, 0.02)' : ''
                } `,
              }}
            >
              <Col
                xs={12}
                xl={5}
                className={!isDesktop ? 'text-center mb-1' : ''}
              >
                <span className="custom-font-text-regular-normal ">
                  {t(item.featureName)}
                </span>
              </Col>
              <Col xs={4} xl={3} className="d-flex justify-content-center">
                {typeof item.VIRPP === 'string' ? (
                  <span className="custom-font-text-regular-normal ">
                    {item.VIRPP}
                  </span>
                ) : (
                  <>
                    {item.VIRPP ? (
                      <StyledIcon>
                        <Image
                          alt="check-circle"
                          src="/static/images/VuexyCheckCircle.svg"
                          width={26}
                          height={26}
                          style={{
                            maxWidth: '100%',
                            height: 'auto',
                          }}
                        />
                      </StyledIcon>
                    ) : (
                      <StyledIcon>
                        <Image
                          alt="cross-circle"
                          src="/static/images/VuexyXCircle.svg"
                          width={26}
                          height={26}
                          style={{
                            maxWidth: '100%',
                            height: 'auto',
                          }}
                        />
                      </StyledIcon>
                    )}
                  </>
                )}
              </Col>
              <Col xs={4} xl={2} className="d-flex justify-content-center">
                {typeof item.Tunecore === 'string' ? (
                  <span className="custom-font-text-regular-normal ">
                    {item.Tunecore}
                  </span>
                ) : (
                  <>
                    {item.Tunecore ? (
                      <StyledIcon>
                        <Image
                          alt="check-circle"
                          src="/static/images/VuexyCheckCircle.svg"
                          width={26}
                          height={26}
                          style={{
                            maxWidth: '100%',
                            height: 'auto',
                          }}
                        />
                      </StyledIcon>
                    ) : (
                      <StyledIcon>
                        <Image
                          alt="cross-circle"
                          src="/static/images/VuexyXCircle.svg"
                          width={26}
                          height={26}
                          style={{
                            maxWidth: '100%',
                            height: 'auto',
                          }}
                        />
                      </StyledIcon>
                    )}
                  </>
                )}
              </Col>
              <Col xs={4} xl={2} className="d-flex justify-content-center">
                {typeof item.Distrokid === 'string' ? (
                  <span className="custom-font-text-regular-normal ">
                    {item.Distrokid}
                  </span>
                ) : (
                  <>
                    {item.Distrokid ? (
                      <StyledIcon>
                        <Image
                          alt="check-circle"
                          src="/static/images/VuexyCheckCircle.svg"
                          width={26}
                          height={26}
                          style={{
                            maxWidth: '100%',
                            height: 'auto',
                          }}
                        />
                      </StyledIcon>
                    ) : (
                      <StyledIcon>
                        <Image
                          alt="cross-circle"
                          src="/static/images/VuexyXCircle.svg"
                          width={26}
                          height={26}
                          style={{
                            maxWidth: '100%',
                            height: 'auto',
                          }}
                        />
                      </StyledIcon>
                    )}
                  </>
                )}
              </Col>
            </Row>
          ))}
        </PlanTable>
      </div>
    </>
  );
}

export default DIstributionCompareChooseUs;

const Subtitle = styled.span`
  line-height: 25px;
  opacity: 0.5;
  text-transform: none !important;
  white-space: nowrap;
`;

const TopBarRow1 = styled.div`
  display: flex;
  box-sizing: border-box;
  padding: 1rem 1rem !important;
`;

const TopHeaderRow = styled(ReactRow)`
  display: flex;
  flex-direction: column;
  margin: 0 !important;

  position: ${(props) => (props.sticky ? 'fixed' : 'static')};
  width: ${(props) => (props.sticky ? '73.9%' : '100%')};

  /* left: 13.5%; */
  // top: 5rem;

  background-color: white;
  z-index: 2;
  border: 1px solid #ebe9f1 !important;
  animation: moveToTop 0.5s ease-in-out;

  border-radius: 6px;

  @media ${noBigTablet} {
    width: ${(props) => (props.sticky ? '94%' : '100%')};
    left: ${(props) => (props.sticky ? '12px' : '0px')};
  }

  @keyframes moveToTop {
    from {
      top: 0rem;
    }
    to {
      top: 5rem;
    }
  }
`;

const PlanTable = styled.div`
  border-radius: 8px;
  border: 1px solid #ebe9f1 !important;
  margin: 0 !important;
  width: 100%;
  padding: 0;

  > div:last-child {
    border-radius: 0px 0px 6px 6px;
  }

  & > *:first-child {
    border-radius: 6px 6px 0px 0px;
  }

  @media ${noBigTablet} {
    border-radius: 0px;
    border-top: none !important;

    > div:last-child {
      border-radius: 0px;
    }

    > div:first-child {
      border-radius: 0px;
    }
  }
`;

const StyledIcon = styled.div`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
`;
